import { matchPath } from 'react-router-dom';

import type { PageSkeletonVariant } from '@/components/ui';

const ORG = '/admin/organizations/:orgSlug';

/**
 * Which `PageSkeleton` stands in for the page at `pathname`: the fallback of a
 * page still downloading (its chunk) and the first paint of the shell. Each
 * route gets the skeleton of its own layout, so when the page then loads its
 * data and shows the same skeleton, nothing changes on screen.
 * Home views (Tours, a collection) and anything unlisted fall to the gallery
 * or the form, the two most common shapes.
 */
export function pageSkeletonFor(pathname: string): PageSkeletonVariant {
  const is = (pattern: string) => !!matchPath({ path: pattern, end: true }, pathname);
  if (is('/admin/account')) return 'account';
  if (is(`${ORG}/settings`)) return 'form';
  if (is(`${ORG}/stats`)) return 'stats';
  if (is(`${ORG}/billing`)) return 'plan';
  if (is(`${ORG}/members`)) return 'table';
  if (is(`${ORG}/projects/:projectSlug/tours/:tourSlug`)) return 'tour';
  if (is('/admin') || is(ORG) || is(`${ORG}/projects/:projectSlug`)) return 'gallery';
  return 'form';
}
